import type { QaReportSelection } from "../../../shared/qaReportOptions";

type ReportDescriptionProps = {
  report?: QaReportSelection | null;
};

export default function ReportDescription({
  report,
}: ReportDescriptionProps) {
  if (!report || report.value === -1) {
    return null;
  }

  return (
    <section
      className="rounded-lg border border-subtle bg-accent-soft p-4"
      aria-live="polite"
      aria-label={`${report.label} description`}
    >
      <p className="text-sm text-brand">{report.description}</p>
      <p className="mt-2 text-sm text-brand">
        <span className="font-semibold">Shows:</span> {report.shows}
      </p>
    </section>
  );
}
